
import {RECURING_ALL_DATA} from "../../constant/ActionType";


export default function AllViewRecuring(state = {
    recuringdata: [],
    statuscode: null,
}, action) {
    switch (action.type) {
        case RECURING_ALL_DATA:
            return {
                ...state,
                recuringdata: action.data,
                    statuscode: action.status
            };

        default:
    }

    return state;
}